import { API_URL } from "env";
interface UploadMediaResponse {
    status: boolean;
    data: {
        id: number;
        folder_id: number;
        name: string;
        table: string;
        image: string;
        type: string;
        created_at: string;
        updated_at: string;
    };
    msg: string;
}
async function uploadMediaImage(file: File) {
    try {
        const formData = new FormData();
        const name = `${Date.now()}_${file.name}`;
        formData.append('image', file);
        formData.append('name', name);

        const response = await fetch(`${API_URL}/api/v1/photo_library`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to upload media image:', error);
        throw error;
    }
}

export { uploadMediaImage };